import { Button, useTranslation } from '@hbs-us/ui';
import { Link } from '@tanstack/react-router';
import { ClipboardList } from 'lucide-react';

/**
 * Empty-state card for the estimates list (legacy `EstimatesListPage`
 * empty-state). Copy switches on the archived filter (UI-SPEC Copywriting
 * Contract). The brand `ClipboardList` glyph replaces the legacy 📋 emoji. The
 * primary "+ Create First Estimate" CTA (orange accent) links to the create
 * route — the only orange CTA in this empty state (UI-SPEC Color accent list #3).
 */
export function EstimatesEmptyState({ showArchived }: { showArchived: boolean }) {
  const { t } = useTranslation();

  return (
    <div className="rounded-md border border-border bg-card p-12">
      <div className="flex flex-col items-center gap-4 text-center">
        <ClipboardList className="size-10 text-muted-foreground" aria-hidden="true" />
        <h2 className="font-display font-semibold text-foreground text-xl">
          {showArchived ? t('estimates:empty.archivedHeading') : t('estimates:empty.heading')}
        </h2>
        <p className="max-w-md text-muted-foreground text-sm">
          {showArchived ? t('estimates:empty.archivedBody') : t('estimates:empty.body')}
        </p>
        {showArchived ? null : (
          <Button asChild>
            <Link to="/estimates/new">{t('estimates:empty.cta')}</Link>
          </Button>
        )}
      </div>
    </div>
  );
}
